import type { BrandConfig, CommonConfig } from 'shared/globalStore/types/globalStore.d.ts'

/**
 * GlobalStore
 * @class
 * @description This class handles the retrieval and parsing of global store data from the DOM.
 */
export default class GlobalStore {
	private brandConfigElement: HTMLElement | null
	private commonConfigElement: HTMLElement | null

	/**
	 * Creates an instance of GlobalStore.
	 * @constructor
	 */
	constructor() {
		this.brandConfigElement = document.getElementById('brandConfig')
		this.commonConfigElement = document.getElementById('commonConfig')
	}

	/**
	 * Retrieves and parses the global store data.
	 * @returns {CommonConfig | null} The parsed global store data or null if not available.
	 */
	get common(): CommonConfig | null {
		if (this.commonConfigElement) {
			try {
				const textContent = this.commonConfigElement.textContent
				if (!textContent || textContent.trim() === '') {
					return null
				}
				return JSON.parse(textContent)
			} catch (error) {
				console.error('Error parsing #commonConfig textContent:', error)
				return null
			}
		}
		return null
	}

	/**
	 * Retrieves and parses the global store configuration.
	 * @returns {BrandConfig | null} The parsed global store configuration or null if not available.
	 */
	get brand(): BrandConfig | null {
		if (this.brandConfigElement) {
			try {
				const textContent = this.brandConfigElement.textContent
				if (!textContent || textContent.trim() === '') {
					return null
				}
				return JSON.parse(textContent)
			} catch (error) {
				console.error('Error parsing #brandConfig textContent:', error)
				return null
			}
		}
		return null
	}
}
